import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import getAxiosInstance from "./../../Utils/axios";
import { DateTime } from "luxon";
import ShowScreens from "../../Components/ShowScreens";
import UpdateScheduleCampaign from "../../Components/UpdateScheduleCampaign";
import MediaPreview from "../../Components/MediaPreview";
import ScreenShow from "../../Components/ScreenShow";
import DateSelector from "../../Components/DateSelector";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function ScheduledMessageLog() {
  const [campaigns, setCampaign] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState("");
  const [searchByType, setSearchByType] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [tillTime, setTillTime] = useState("");
  const [isClick, setIsClick] = useState(false);
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCampaign, setTotalCampaign] = useState(0);
  // console.log("campaigns ====>", campaigns);
  const getCampaign = (from, till) => {
    let jsonData = {
      limit: limit,
      page: pageNumber * limit,
      search: searchFilter,
      filter_by: searchByType,
      schedule: true,
      from_time: fromTime,
      to_time: tillTime,
    };
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/campaigns", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        if (res.data.status === "success") {
          // console.log(res.data);
          setTotalCampaign(res.data.totalCount);
          setCampaign(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCampaign("", "");
  }, [limit, pageNumber, searchByType, isClick]);

  const changePage = ({ selected }) => setPageNumber(selected);

  function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    // return minutes + " Min";
  }
  console.log("xxxxxx", campaigns);

  let time = 0;
  let finalTime = [];
  const y = campaigns?.map((s) => {
    return s.schedules?.map((t, index) => {
      const st = new Date(t.to_time) - new Date(t.from_time);
      time = time + st;
      if (index == s.schedules.length - 1) {
        finalTime.push(time);
        time = 0;
      }
      // console.log("final time====>", finalTime);
      return finalTime;
    });
    // return s.schedules.length;
  });
  // console.log("eeeeeeeeee", finalTime);

  // console.log("qqqqqq====>", edata);

  // console.log("cccyyyyyy==", y);
  // const startDateTime = new Date(
  //   `${campaigns?.start_time.split("T")[0]} ${campaigns?.from_time}`
  // );
  // const endDateTime = new Date(
  //   `${campaigns?.end_time.split("T")[0]} ${campaigns?.to_time}`
  // );
  // const durationInMilliseconds = endDateTime - startDateTime;
  // const durationFormatted = millisToMinutesAndSeconds(durationInMilliseconds);

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">Scheduled Messages Report</h1>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div class="card-tools">
                      <DateSelector
                        action={() => setIsClick(!isClick)}
                        from={setFromTime}
                        to={setTillTime}
                      />
                    </div>
                  </div>

                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 10 }}>SL No.</th>
                          <th>Campaign</th>
                          <th>Message</th>
                          <th>User Assigned</th>
                          <th>Screen(s)</th>
                          <th>Date and Time</th>
                          <th>Campaign Duration</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>Loading Messge Logs ...</td>
                          </tr>
                        )}
                        {!isLoading && totalCampaign === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>No Message Log Found</td>
                          </tr>
                        )}

                        {campaigns?.map((campaign, i) =>
                          campaign.status != "live" ? (
                            <tr key={i}>
                              <td>{i + 1}.</td>
                              <td>
                                <ScreenShow
                                  campaign={campaign}
                                  Toast={Toast}
                                  getAxiosInstance={getAxiosInstance}
                                  screenCount={0}
                                  showCampaign={true}
                                />
                              </td>
                              <td>
                                <MediaPreview
                                  type={campaign.media?.type}
                                  text={campaign.media?.text}
                                  images={campaign.media?.image}
                                  video={campaign.media?.video}
                                />
                              </td>
                              <td>
                                {campaign.user?.first_name}{" "}
                                {campaign.user?.last_name}
                              </td>
                              <td>
                                <ShowScreens screens={campaign.screens} />
                              </td>
                              <td>
                                {`${DateTime.fromMillis(
                                  new Date(campaign.start_time).getTime()
                                ).toFormat(
                                  "dd LLL yyyy"
                                )} ${DateTime.fromMillis(
                                  new Date(
                                    `2023-06-20 ${campaign.from_time}`
                                  ).getTime()
                                ).toFormat("hh:mm a")}
                                  `}{" "}
                                -{" "}
                                {`${DateTime.fromMillis(
                                  new Date(campaign.end_time).getTime()
                                ).toFormat(
                                  "dd LLL yyyy"
                                )} ${DateTime.fromMillis(
                                  new Date(
                                    `2023-06-20 ${campaign.to_time}`
                                  ).getTime()
                                ).toFormat("hh:mm a")}`}
                              </td>
                              {/* <td>
                              {millisToMinutesAndSeconds(
                                new Date(
                                  `2023-06-20 ${campaign.to_time}`
                                ).getTime() -
                                  new Date(
                                    `2023-06-20 ${campaign.from_time}`
                                  ).getTime()
                              )}
                            </td> */}
                              {/* <td>
                              `{DateTime.fromMillis(
                                new Date(campaign.start_time).getTime()
                              ).toFormat("dd LLL yyyy")}{" "}
                              $
                              {DateTime.fromMillis(
                                new Date(
                                  `2023-06-20 ${campaign.from_time}`
                                ).getTime()
                              ).toFormat("hh:mm a")}{" "}
                              -{" "}
                              {DateTime.fromMillis(
                                new Date(campaign.end_time).getTime()
                              ).toFormat("dd LLL yyyy")}{" "}
                              $
                              {DateTime.fromMillis(
                                new Date(
                                  `2023-06-20 ${campaign.to_time}`
                                ).getTime()
                              ).toFormat("hh:mm a")}`
                            </td> */}
                              <td>
                                {/* {millisToMinutesAndSeconds(
                                  campaign.to_time - campaign.from_time
                                )} */}
                                {millisToMinutesAndSeconds(finalTime[i])}
                                {/* {durationFormatted} */}
                                {/* {millisToMinutesAndSeconds(
                                  new Date(
                                    `${campaign.end_time.split("T")[0]} ${
                                      campaign.to_time
                                    }`
                                  ) -
                                    new Date(
                                      `${campaign.start_time.split("T")[0]} ${
                                        campaign.from_time
                                      }`
                                    )
                                )} */}

                                {/* {console.log(
                                  "bbbbbbbbbbbbbbbb",
                                  new Date(
                                    `${campaign.start_time.split("T")[0]} ${
                                      campaign.from_time
                                    }`
                                  )
                                )} */}
                              </td>
                            </tr>
                          ) : null
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {totalCampaign > limit ? (
                      <ReactPaginate
                        previousLabel={"«"}
                        nextLabel={"»"}
                        pageCount={Math.ceil(totalCampaign / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
